<template>
  <div id="app">

    <ImagePreloader @isReady="onImagesReady"/>

    <Scene 
      ref="scene"
      v-if="introReady"
      @actionsChanged="onActionsChanged"
      @isReady="onSceneReady"
      :handleSceneClick="handleSceneClick"
      @event="handleSceneClick"
      :isPaused="scenePaused"
      :isVisible="step == 'stage'"
    />
    
    <transition mode="in-out" name="fade-instructions">
      <Instructions v-if="showInstructions"/>
    </transition>

    <transition mode="in-out" name="fade-controls">
      <Controls
        v-if="step == 'stage'"
        @toggleZoom="onControlsToggleZoom"
        @goBackward="onControlsBackward"
        @goForward="onControlsForward"
        @stopMovement="onControlsStopMovement"
        @goToSignup="setStep"
        :isMovingUp="isMovingUp"
        :isMovingDown="isMovingDown"
        :isZoomed="isZoomed"
      />
    </transition>

    <transition mode="in-out" name="walls">
      <Walls v-if="step != 'stage'"/>
    </transition>

    <transition mode="in-out" name="curtains">
      <Curtains v-if="step != 'stage'"/>
    </transition>

    <Intro ref="intro" v-if="step == 'intro'"  :rebuild="rebuild" :search="search" @goToStage="setStep"/>

    <transition mode="in-out" name="fade-delayed">
      <Signup @goBack="setStep" v-if="step == 'signup'"/>
    </transition>

    <transition mode="in-out" name="fade">
      <ShareSite v-if="!hideShare && step != 'stage'"/>
    </transition>

    <transition mode="in-out" name="fade-delayed">
      <Search @goBack="setStep" v-if="step == 'search'" />
    </transition>

    <transition mode="in-out" name="fade">
      <SearchBtn v-if="step == 'stage' && !hideShare" @goToSearch="setStep"/>
    </transition>

    <transition mode="in-out" name="fade">
      <ShareBrick
        v-if="brickSelected != false && step == 'stage'"
        :brickSelected="brickSelected"
        :firstName="brickFirstName"
        :lastName="brickLastName"
      />
    </transition>


    
  </div>
</template>
<script>
  import ImagePreloader from './components/ImagePreloader.vue'
  import Scene from './components/Scene.vue'
  import Intro from './components/Intro.vue'
  import Signup from './components/Signup.vue'
  import Curtains from './components/Curtains.vue'
  import Walls from './components/Walls.vue'
  import Controls from './components/Controls.vue'
  import ShareSite from './components/ShareSite.vue'
  import Search from './components/Search.vue'
  import SearchBtn from './components/SearchBtn.vue'
  import ShareBrick from './components/ShareBrick.vue'
  import Instructions from './components/Instructions.vue'

  export default {

    name: 'App',

    components: {
      ImagePreloader,
      Scene,
      Intro,
      Signup,
      Curtains,
      Walls,
      Controls,
      ShareSite,
      Search,
      SearchBtn,
      ShareBrick,
      Instructions,
    },

    data() {
      return {
        step: 'intro',
        introReady: false,
        scenePaused: true,
        brickSelected: false,
        brickFirstName: '',
        brickLastName: '',
        isZoomed: false,
        hash: false,
        rebuild: false,
        search: false,
        showInstructions: false,
        isMovingUp: false,
        isMovingDown: false,
        hideShare: false,
      }
    },

    methods: {
      setStep(step) {
        this.step = step;
        this.scenePaused = step != 'stage' ? true : false;
        //console.log( step );
        if(this.step == 'stage'){
          this.showInstructions = true;
          this.hideShare = true;
          setTimeout( () => {
            this.hideShare = false;
          }, 2200);
          setTimeout( () => {
            this.showInstructions = false;
          }, 3500);
        }
      },
      onSceneReady() {
        if(this.step == 'intro'){
          if(this.hash){
            setTimeout( () => {
              this.setStep('stage');
            }, 3000);
          } else {
            this.$refs.intro.updateLoader();
          }
        } 
      },
      onImagesReady() {
        this.introReady = true;
      },

      onControlsForward() {
        this.showInstructions = false;
        this.$refs.scene.updateActions( 'up', true );
      },
      onControlsBackward() {
        this.showInstructions = false;
        this.$refs.scene.updateActions( 'down', true );
      },
      onControlsStopMovement(){
        this.$refs.scene.updateActions( 'up', false );
        this.$refs.scene.updateActions( 'down', false );
      },

      onActionsChanged(actions){
        //console.log('actionschanged', actions.zoom)
        if(actions.zoom != this.isZoomed){
          this.isZoomed = actions.zoom;
        }

        if(actions.up == true){
          this.isMovingUp = true;
        } else {
          this.isMovingUp = false;
        }

        if(actions.down == true){
          this.isMovingDown = true;
        } else {
          this.isMovingDown = false;
        }

      },
      onControlsToggleZoom() {
        this.showInstructions = false;
        this.$refs.scene.updateActions( 'zoom', !this.isZoomed );
      },

      openLink(link){
        window.open(link, '_blank');
      },

      handleSceneClick(e){
        if(e.name == 'brick'){
          if(e.type == 'select'){
            this.brickSelected = e.data.uid;
            this.brickFirstName = e.data.firstName;
            this.brickLastName = e.data.lastName;
          } else {
            this.brickSelected = false;
          }
        }else if(e.name == 'sign1right'){
          this.onControlsToggleZoom();
        }else if(e.name == 'sign2left'){
          this.setStep('signup');
        } else if(e.name == 'musicleft' || e.name == 'pianoleft') {
          this.openLink('https://elton.lnk.to/DiamondsHDSR');
        } else if(e.name == 'musicright' || e.name == 'pianoright') {
          this.openLink('https://eltonjohn.lnk.to/bestofSR/spotify');
        } else if(e.name == 'shop1left') {
          this.openLink('https://EltonJohn.lnk.to/VintageGBYBRTourTShirt/');
        } else if(e.name == 'shop1right') {
          this.openLink('https://EltonJohn.lnk.to/GBYBRPuzzle/');
        } else if(e.name == 'shop2left') {
          this.openLink('https://EltonJohn.lnk.to/Keyring/');
        } else if(e.name == 'shop2right') {
          this.openLink('https://EltonJohn.lnk.to/75Poster/');
        } else if(e.name == 'tv1left') {
          this.openLink('https://EltonJohn.lnk.to/EgoVideoWE');
        } else if(e.name == 'tv1right') {
          this.openLink('https://EltonJohn.lnk.to/InNeonWE');
        } else if(e.name == 'tv2left') {
          this.openLink('https://EltonJohn.lnk.to/LiveLikeHorsesWE');
        } else if(e.name == 'tv2right') {
          this.openLink('https://EltonJohn.lnk.to/NobodyWinsWE');
        } else if(e.name == 'tv3left') {
          this.openLink('https://EltonJohn.lnk.to/RunawayTrainWE');
        } else if(e.name == 'tv3right') {
          this.openLink('https://EltonJohn.lnk.to/SimpleLifeVideoWE');
        } else if(e.name == 'tv4left') {
          this.openLink('https://EltonJohn.lnk.to/WhoWearsTheseShoesVideoWE');
        } else if( e.name == 'rocketleft' || e.name == 'rocketright') {
          this.openLink('https://www.eltonjohn.com/rocket-club');
        }
        
      },

      onResize() {
        const windowHeight = window.innerHeight;
        document.documentElement.style.setProperty('--viewport-height', windowHeight + 'px');
      },
    },

    created: function () {

      addEventListener('resize', this.onResize);
      this.onResize();

    },    

    mounted() {
      this.hash = window.location.hash;
      if (this.hash && this.hash.includes("access_token")) {
        this.step = 'signup';
      } else if (this.hash && this.hash.includes("claimed") ) {
        this.rebuild = true;
        window.location = window.location.pathname + this.hash.split('&')[0];
      } else if (this.hash && this.hash.includes("searched")) {
        this.search = true;
        window.location = window.location.pathname + this.hash.split('&')[0];
      }
    },

  }
</script>
<style lang="scss">
  @import '/assets/style/styles.scss';
</style>